"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customParseDate = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var customParseDate = function customParseDate(dateString, dateFormat) {
  var momentDate = (0, _moment.default)(dateString, dateFormat, true);
  // check validity of a date with moment.js method
  if (momentDate.isValid()) {
    return {
      year: momentDate.year(),
      month: momentDate.month() + 1,
      day: momentDate.date()
    };
  }
  return undefined;
};
exports.customParseDate = customParseDate;